// OBT F3-D — Yeni varlık ekleme diyaloğu.
import { useEffect, useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { Loader2 } from 'lucide-react';
import { ASSET_TYPE_CHOICES } from './memoryEnums';

export default function AddAssetDialog({ open, onClose, onCreate, error = null }) {
  const [assetType, setAssetType] = useState('pool');
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (open) {
      setAssetType('pool');
      setName('');
      setDescription('');
      setSubmitting(false);
    }
  }, [open]);

  const handleConfirm = async () => {
    if (submitting || !assetType) return;
    setSubmitting(true);
    try {
      await onCreate({ assetType, name: name.trim(), description: description.trim() });
      onClose();
    } catch {
      setSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(v) => !submitting && !v && onClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Yeni Varlık Ekle</DialogTitle>
          <DialogDescription>
            Parka bir varlık kimliği ekleyin (örn. havuz, basketbol sahası). Geçmiş
            kayıtları bu varlığın altında birikir.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <div className="space-y-1.5">
            <Label htmlFor="asset-type">Varlık tipi</Label>
            <select
              id="asset-type"
              className="h-9 w-full rounded-md border border-gray-300 bg-white px-2 text-sm"
              value={assetType}
              onChange={(e) => setAssetType(e.target.value)}
              disabled={submitting}
            >
              {ASSET_TYPE_CHOICES.map((c) => (
                <option key={c.value} value={c.value}>{c.label}</option>
              ))}
            </select>
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="asset-name">Ad (opsiyonel)</Label>
            <Input
              id="asset-name"
              value={name}
              maxLength={200}
              placeholder="Ör. Kuzey havuzu"
              onChange={(e) => setName(e.target.value)}
              disabled={submitting}
            />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="asset-desc">Açıklama (opsiyonel)</Label>
            <Textarea
              id="asset-desc"
              value={description}
              rows={2}
              maxLength={2000}
              onChange={(e) => setDescription(e.target.value)}
              disabled={submitting}
            />
          </div>
          {error && <p role="alert" className="text-sm text-red-600">{error}</p>}
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} disabled={submitting}>Vazgeç</Button>
          <Button onClick={handleConfirm} disabled={submitting || !assetType}>
            {submitting && <Loader2 className="mr-2 h-4 w-4 animate-spin" aria-hidden="true" />}
            Varlık Ekle
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
